import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MunicipioIBGEService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrlocalizacao/municipioibge`;
  estado: string = '';

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(`${this.url}/${this.estado}`, {params});
  }

  getObjectByValue(value: string): Observable<any> {
    return this.httpClient.get(`${this.url}/${this.estado}/${value}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CCC2CODMUN', divider: 'Código', optional: true, gridColumns: 6, label: 'Codigo'},
      {property: 'CCC2MUN'   , divider: 'Nome'  , optional: true, gridColumns: 6, label: 'Descrição'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CCC2CODMUN', label: 'Código'},
      {property: 'CCC2MUN'   , label: 'Nome'},
    ];
  }

  getFieldFormater(value: any): string {
    return `${value.CCC2CODMUN} - ${value.CCC2MUN}`;
  }
}
